import { Global } from '@emotion/react/macro';

export default Global;
